module.exports = __webpack_public_path__ + "img/more_60_days.1c1ab6f0.svg";